import * as crypto from "crypto";

const keys = {
  TOKEN_KEY: "aXoiGozVvLAxWFnr",
};

const dumpToken = (token: any) => {
  localStorage.setItem(keys.TOKEN_KEY, JSON.stringify(token));
};

const dumpTempReportData = (data: ReportStorageData): string => {
  const key = `${crypto.randomBytes(20).toString("hex")}`;
  localStorage.setItem(key, JSON.stringify(data));

  return key;
};

const loadTempReportData = (key: string): ReportStorageData | null => {
  const data = localStorage.getItem(key);
  if (data !== null) {
    return JSON.parse(data);
  }

  return null;
};

const dumpNewGm6 = (value: "0" | "1") => {
  const key = `new_gm6`;
  localStorage.setItem(key, value);

  return key;
};

const loadNewGm6 = () => {
  const key = `new_gm6`;
  const data = localStorage.getItem(key);
  if (data !== null) {
    return JSON.parse(data);
  }

  return null;
};

export {
  dumpToken,
  dumpTempReportData,
  loadTempReportData,
  dumpNewGm6,
  loadNewGm6,
};
